import { css } from 'styled-components';
export const siteWide = css `
  margin: 0 auto;
  max-width: calc(var(--siteWidth) + var(--sitePadding) + var(--sitePadding));
  padding: 0 var(--sitePadding);
  width: 100%;
`;
export const baseGrid = css `
  display: grid;
  column-gap: var(--gutterWidth);
  grid-template-columns: repeat(24, 1fr);
`;
